import { FC } from 'react';
import { WithScope } from '@mews-commander/types';
import { OverlayedLoader } from '@mews-commander/ui';
import { useCommanderSelector } from '@mews-commander/utils';
import { WithChildren } from '@optimus-web/common';
import { isFetching as isBillingInitializing } from '../ducks/billing';
import { isBillFetching } from '../ducks/bills';
import { isPaymentFetching } from '../ducks/payments';

type BillingPageLoadingWrapperProps = WithScope & WithChildren;

export const BillingPageLoadingWrapper: FC<BillingPageLoadingWrapperProps> = ({ scope, children }) => {
    const meta = { scope };
    const isInitializing = useCommanderSelector((state) => isBillingInitializing(state, meta));
    const isPaymentLoading = useCommanderSelector((state) => isPaymentFetching(state, meta));
    const isBillLoading = useCommanderSelector((state) => isBillFetching(state, meta));

    const showOverlayedLoader = isPaymentLoading || isBillLoading;

    if (isInitializing) {
        return <OverlayedLoader fixed show />;
    }

    return (
        <>
            {children}
            <OverlayedLoader fixed show={showOverlayedLoader} />
        </>
    );
};
